import type { ReactElement } from 'react';
import { skeletonLine } from '@/components/ui/skeleton';

/** Skeleton contextual con la forma de la matriz (encabezado + filas), no un
 *  spinner genérico (UX-LOAD-01). */
export function RolesAccessSkeleton(): ReactElement {
  return (
    <div className="card" aria-busy="true" aria-label="Cargando roles y accesos">
      <div className="cb" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <div className={skeletonLine({ width: 40, height: 'md' })} />
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className={skeletonLine({ width: 100, height: 'md' })} />
        ))}
      </div>
    </div>
  );
}
